/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'user': {
    width: 21,
    height: 23,
    viewBox: '0 0 21 23',
    data: '<path pid="0" d="M10.063 11.5c-3.19 0-5.75-2.56-5.75-5.75 0-3.145 2.56-5.75 5.75-5.75 3.144 0 5.75 2.605 5.75 5.75 0 3.19-2.606 5.75-5.75 5.75zm3.997 1.438c3.325 0 6.065 2.74 6.065 6.064v1.842A2.157 2.157 0 0117.969 23H2.156A2.129 2.129 0 010 20.844v-1.842c0-3.324 2.695-6.064 6.02-6.064h.763c.988.494 2.112.718 3.28.718 1.167 0 2.246-.224 3.234-.719h.763z" _fill="#3E4749"/>'
  }
})
